import * as React from 'react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { TooltipHost, TooltipOverflowMode } from 'office-ui-fabric-react/lib';
var styles = require('./ColoredBulletOption.scss');
var classNames = require('classnames/bind').bind(styles);
/**
 *  This renders a colored bullet with option text.
 */
export default function ColoredBulletOption(props) {
    return (React.createElement("div", { className: styles.optionWrapper },
        React.createElement(Icon, { className: classNames(styles.coloredBullet, props.iconClassName), style: { color: props.color }, iconName: "CircleFill" /* CircleFill */, "aria-hidden": "true" }),
        React.createElement("div", { className: styles.optionLabel },
            React.createElement(TooltipHost, { id: "closeDialogButtonID", content: props.label, overflowMode: TooltipOverflowMode.Parent, calloutProps: { gapSpace: 0, isBeakVisible: false } },
                React.createElement("span", { "aria-describedby": "closeDialogButtonID" }, props.label)))));
}
//# sourceMappingURL=ColoredBulletOption.js.map